import React, { CSSProperties } from "react"


interface SearchFormContainerProps {
    inputs: React.ReactNode,
    clearSearchButton: React.ReactNode
    sortInputs?: React.ReactNode
    style?: CSSProperties
    clearContainerStyle?: CSSProperties
    // Narrower fields so many filters fit in one row on desktop (still wraps on small screens)
    compact?: boolean
}

const CONTAINER_CLASS = "search-form-container";
const INPUT_CONTAINERS = "search-fields"
const CLEAR_AND_SORT_CONTAINER = 'search-clear-and-sort-container'

const SearchFormContainer = ({
    inputs,
    clearSearchButton,
    sortInputs,
    style,
    clearContainerStyle,
    compact
}: SearchFormContainerProps) => {

    return (
        <div className={compact ? `${CONTAINER_CLASS} ${CONTAINER_CLASS}--compact` : CONTAINER_CLASS} style={style}>
            <div className={INPUT_CONTAINERS}>
                {inputs}
            </div>
            <div className={CLEAR_AND_SORT_CONTAINER} style={clearContainerStyle}>
                {clearSearchButton}
                <div>
                    {sortInputs}
                </div>
            </div>
        </div>
    )
}



export default SearchFormContainer